<template>
  <div class="row country-filter pad-top">
    <div class="col-md-12">
      <MultiSelect track-by="name" :options="Storage.countries" :searchable="true" :allowEmpty="false"
                   :custom-label="customLabel" :show-labels="false" v-model="Storage.selectedCountry"
                   @input="dispatchInputAction" :disabled="disabled" ref="CountryFilter">
        <template slot="loading" scope="props">
          <div class="country-selected-flag">
            <i class="option__image flag" :class="'flag-' + Storage.selectedCountry.code.toLowerCase()" v-if="$refs.CountryFilter && !$refs.CountryFilter.isOpen"></i>
          </div>
        </template>
        <template slot="singleLabel" scope="props">
          <span class="option__singleTitle">{{ $t('country.' + props.option.id) }}</span>
        </template>
        <template slot="option" scope="props">
          <div class="option__desc">
                        <span class="option__title">
                            <i class="option__image flag" :class="'flag-' + props.option.code.toLowerCase()"></i>
                            <span>{{ $t('country.' + props.option.id) }} <b v-if="Storage.developMode">({{ props.option.id }})</b></span>
                        </span>
          </div>
        </template>
      </MultiSelect>
    </div>
  </div>
</template>


<script>
import MultiSelect from 'vue-multiselect'
import Storage from '../../api/Storage'
import API from '../../api/API'
import Helper from '../../api/Helper'

export default {
  name: 'oneCountryFilter',
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect
  },
  data () {
    return {
      Storage: Storage,
      countryCode: ''
    }
  },
  methods: {
    customLabel (item) {
      return this.$root.$t('country.' + item.id)
    },
    dispatchInputAction () {
      this.$root.$emit('country_selected')
    }
  },
  beforeDestroy () {
    this.$root.$off('country_selected')
  }
}
</script>

<style>
.pad-top{
  padding-top:5px;
}
.option__singleTitle{
  margin: 40px;
}
.multiselect__single{
  background: none
}
</style>



// WEBPACK FOOTER //
// OneCountryFilter.vue?27eb52e0